export default function currency(value) {
  /*     if (typeof value !== "number") {
        return value;
    } */

  let n_value = parseFloat(value);
  if (isNaN(n_value)) {
    return value;
  }

  var formatter = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
  });
  return formatter.format(n_value);
}
